<template>
  <div class="main">
    <date></date>

    <div class="headerTop"></div>

    <backBtn></backBtn>

    <div class="activeTitle" style="margin-top: 60px; margin-bottom: 40px">
      基础信息
    </div>

    <div class="container">
      <div class="small_title">
        <img
          style="width: 575px; height: 97px"
          src="../../assets/images/img_title@2x.png"
          alt=""
        />
      </div>
      <div class="total">
        <div class="totalItem">
          <div class="title">住宅户数</div>
          <div class="num">
            {{ infoData.zzhs || 0 }} <span class="unit">户</span>
          </div>
        </div>
        <div class="totalItem totalItem1">
          <div class="title">建筑面积</div>
          <div class="num">
            {{ infoData.jzmj || 0 }} <span class="unit">㎡</span>
          </div>
        </div>
      </div>

      <div class="total" style="margin-top: 100px">
        <div class="totalItem totalItem2">
          <div class="title">小区车位</div>
          <div class="num">
            {{ infoData.xqcw || 0 }} <span class="unit">个</span>
          </div>
        </div>
        <div class="totalItem totalItem3">
          <div class="title">收费标准</div>
          <div class="num detail-num">
            <span class="detail">住宅区：</span>{{ infoData.sfbzzzq || 0 }}
            <span class="unit">元/㎡</span>
          </div>
          <div class="num detail-num">
            <span class="detail">商业区：</span>{{ infoData.sfbzsyq || 0 }}
            <span class="unit">元/㎡</span>
          </div>
        </div>
      </div>
      <div class="total" style="margin-top: 100px">
        <div class="totalItem totalItem4">
          <div class="title">常驻人口</div>
          <div class="num">
            {{ infoData.czrk || 0 }} <span class="unit">人</span>
          </div>
        </div>
        <div class="totalItem totalItem5">
          <div class="title">党员人数</div>
          <div class="num">
            {{ infoData.dyrs || 0 }} <span class="unit">人</span>
          </div>
        </div>
      </div>

      <div class="total" style="margin-top: 100px">
        <div class="totalItem totalItem6">
          <div class="title">学龄前儿童</div>
          <div class="num">
            {{ infoData.xlqet || 0 }} <span class="unit">人</span>
          </div>
        </div>
        <div class="totalItem totalItem7">
          <div class="title">60岁以上老人</div>
          <div class="num">
            {{ infoData.lssyslr || 0 }} <span class="unit">人</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer1">
      <div class="telphone">
        <h4>市区住建部门</h4>
        <div class="line"></div>
        <p>泸州市物业管理中心物管科：0830-2868716</p>
        <p>江阳区住建局：0830-3123550</p>
      </div>
      <div class="telphone">
        <h4>综合执法大队</h4>
        <div class="line"></div>
        <p>泸州市城管局：0830-3190602</p>
        <p>江阳区综合行政执法局：0830-6608765</p>
      </div>
    </div>
    <div class="footer1">
      <div class="telphone">
        <h4>市场监督管理</h4>
        <div class="line"></div>
        <p>泸州市市场监督管理局：0830-2593511</p>
        <p>江阳区市场监督管理局：0830-3190055</p>
      </div>
      <div class="telphone">
        <h4>交通管理</h4>
        <div class="line"></div>
        <p>江阳区交警挪车电话：0830-3990771</p>
        <p>交警二大队（江阳区）：0830-3990771</p>
      </div>
    </div>
    <div class="footer1">
      <div class="telphone">
        <h4>社区管理</h4>
        <div class="line"></div>
        <p>黄桷坪社区：0830-6662062</p>
        <p>蓝田派出所：0830-3990953</p>
      </div>
      <div class="telphone" style="opacity: 0"></div>
    </div>
  </div>
</template>

<script>
import backBtn from "../../components/back/index.vue";
import api from "@/api/baseInfo";
import date from "../../components/header/index.vue";
export default {
  name: "",
  components: { backBtn, date },
  data() {
    return {
      infoData: {},
    };
  },
  created() {},
  mounted() {
    this.init();
  },

  methods: {
    init() {
      api.jcxxsjtj().then((res) => {
        if (res.data.code == 200) {
          this.infoData = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 717px;
  background: linear-gradient(
    154deg,
    rgba(0, 132, 255, 0.66) 0%,
    rgba(62, 126, 246, 0) 100%
  );
  border-radius: 24px;
  border: 2px solid #70e2ee;

  margin-top: 20px;
  padding: 180px 80px 100px 80px;
}

.total {
  display: flex;
  justify-content: space-between;
  margin: 0 40px;
  .totalItem {
    width: 260px;
    height: 77px;

    background: url("../../assets/images/index_dataico_zzhs.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem1 {
    background: url("../../assets/images/index_dataico_jzmj.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem2 {
    background: url("../../assets/images/index_dataico_xqcw@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem3 {
    background: url("../../assets/images/index_dataico_sfbz@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem4 {
    background: url("../../assets/images/index_dataico_czrk@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem5 {
    background: url("../../assets/images/index_dataico_dyrs@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem6 {
    background: url("../../assets/images/index_dataico_xlqet@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  .totalItem7 {
    background: url("../../assets/images/index_dataico_oldman@2x.png") no-repeat;
    background-size: 100% 100%;
  }

  .title {
    color: #ffffff;
    font-weight: 550;
    font-size: 20px;
    margin-top: 15px;
    margin-left: 90px;
  }
  .num {
    min-width: 100%;
    color: #2ef8ff;
    font-size: 34px;
    margin-left: 90px;
    font-weight: 600;
    font-family: "barlownumber";
  }
  .unit {
    font-size: 16px;
    color: #2ef8ff;
  }
  .detail {
    color: #ffffff;
    font-weight: 400;

    font-size: 14px;
  }
  .detail-num {
    font-size: 16px;
    font-family: "fontNum";
  }
}

.small_title {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.time {
  position: absolute;
  top: 23px;
  left: 60px;
  font-family: "barlownumber";
  font-weight: 700;
  font-size: 32px;
  line-height: 34px;
  letter-spacing: 2px;
  text-shadow: 0px 2px 2px #002853;
  text-align: center;
  font-style: normal;
  text-transform: none;
  color: #fff;
}
.year {
  position: absolute;
  top: 18px;
  right: 60px;
  width: 140px;
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.yyyy {
  font-size: 20px;
  color: #fff;
  font-family: "barlownumber";
}
.nongli {
  color: #fff;
  font-size: 14px;
}

.footer {
  color: #fff;
  margin-top: 40px;
  h4 {
    margin: 10px;
  }

  p {
    margin: 10px;
  }
}
.footer1 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  .telphone {
    width: 45%;
    height: 113px;
    padding: 20px;
    background: linear-gradient(180deg, #003a87 0%, rgba(0, 40, 93, 0) 100%);
    box-shadow: inset 0px 0px 10px 0px rgba(39, 144, 255, 0.78);
    border-radius: 8px 8px 8px 8px;
    // border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(95.00000193715096, 233.00000131130219, 255, 0.6196078658103943),
        rgba(105.00000134110451, 183.00000429153442, 255, 1)
      )
      1 1;
  }
  h4 {
    margin: 10px;
  }

  p {
    margin: 10px;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 0.4;
}
</style>
